import styled from '@emotion/styled';
import { Collapse } from '@mui/material';

export const CollapseStyled = styled(Collapse)`
  .MuiCollapse-wrapperInner {
    width: 95%;
  }
`;
